import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { Loading } from 'Components/Partials';
import MainStageLayout from 'Components/MainStage/Layouts/MainStageLayout';

import { User } from 'Services';

import Base from './Base';

export default class MainStage extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = false;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
        currentPoll: null,
        userSettings: User.data.main_stage_settings,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();

        User.on('change', this.handleUpdateSettings);
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();

        User.removeListener('change', this.handleUpdateSettings);
    };

    /**
     * @method handleUpdateSettings
     */
    handleUpdateSettings = () => this.setState({
        userSettings: User.data.main_stage_settings,
    });

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { working, currentSession, currentPoll, userSettings } = this.state;

        return (
            <Authenticated>
                {working && (<Loading/>)}

                {!working && (
                    <MainStageLayout
                        userSettings={userSettings}
                        currentSession={currentSession}
                        currentPoll={currentPoll}
                    />
                )}
            </Authenticated>
        );
    }
}
